var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBillingFrequency(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 36.5,
    r: 32.5,
    fill: "#27B783"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.0847 47.9886C34.5431 47.1342 32.45 45.6072 30.8055 43.4073C29.1609 41.2075 28.3387 38.6766 28.3387 35.8146C28.3387 35.1312 28.3921 34.4478 28.4989 33.7643C28.6056 33.0809 28.7765 32.4081 29.0114 31.746L26.9611 32.9314L26 31.2975L31.5423 28.0938L34.746 33.6041L33.0801 34.5652L31.222 31.3936C30.923 32.0984 30.6934 32.8246 30.5332 33.5721C30.373 34.3196 30.2929 35.0778 30.2929 35.8467C30.2929 38.3242 31.0244 40.5133 32.4874 42.4142C33.9504 44.315 35.8139 45.6072 38.0778 46.2906L37.0847 47.9886ZM46.3112 31.3295V29.4073H49.9954C48.9703 27.9977 47.6834 26.8978 46.135 26.1076C44.5866 25.3173 42.9367 24.9222 41.1854 24.9222C39.7117 24.9222 38.3394 25.1892 37.0687 25.7231C35.7979 26.2571 34.6712 26.9939 33.6888 27.9336L32.6957 26.2037C33.849 25.1998 35.1411 24.415 36.5721 23.849C38.0031 23.283 39.5301 23 41.1533 23C43.0328 23 44.8055 23.3791 46.4714 24.1373C48.1373 24.8955 49.5789 25.9687 50.7963 27.357V24.9222H52.7185V31.3295H46.3112ZM44.8696 51.1922L39.3272 47.9886L42.5309 42.4783L44.1648 43.4394L42.3066 46.6751C45.0831 46.3974 47.4058 45.2281 49.2746 43.167C51.1434 41.106 52.0778 38.6659 52.0778 35.8467C52.0778 35.3982 52.0511 34.9603 51.9977 34.5332C51.9443 34.106 51.8642 33.6789 51.7574 33.2517H53.7437C53.8291 33.6789 53.8932 34.106 53.9359 34.5332C53.9786 34.9603 54 35.3875 54 35.8146C54 38.8688 53.0442 41.5706 51.1327 43.9199C49.2212 46.2693 46.7811 47.7536 43.8124 48.373L45.8307 49.5584L44.8696 51.1922Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: 0,
    y: 0,
    width: 81,
    height: 81,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingFrequency);
export default __webpack_public_path__ + "static/media/billingFrequency.6227fa7452dff2cf17b790f0c49f31c1.svg";
export { ForwardRef as ReactComponent };